import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("rect", {
  x: "2",
  y: "2",
  width: "4",
  height: "20",
  rx: "1"
}), ___EmotionJSX("rect", {
  x: "10",
  y: "2",
  width: "4",
  height: "12",
  rx: "1"
}), ___EmotionJSX("rect", {
  x: "18",
  y: "2",
  width: "4",
  height: "16",
  rx: "1"
}));
export default SVG;